import styled from 'styled-components'

export const StyledButton = styled.button`
  background-color: transparent;
  border: none;
  transition: color .2s cubic-bezier(.785,.135,.15,.86) 0s;
  display: flex;
  align-items: center;
  justify-content: center;
`
